<div class="cont">
    <H2 class="head">{{'prof-sotr.head'|translate}}</H2>
    <p class="head" [innerHTML]="'prof-sotr.text' | translate"></p>
</div>
<docs-table [translations]="translations"></docs-table>


<div class="cont">
    <p [innerHTML]="'prof-sotr.text9' | translate"></p>
    <div class="display-row">
        <img src="assets/components/profcom/09-05-2025-1.png" alt="Фотография" height="500">
        <img src="assets/components/profcom/09-05-2025-2.png" alt="Фотография" height="500">
        <img src="assets/components/profcom/09-05-2025-3.png" alt="Фотография" height="500">
    </div>
    <p [innerHTML]="'prof-sotr.text8' | translate"></p>
    <div class="display-row">
        <img src="assets/components/profcom/01-05-2025-1.png" alt="Фотография" height="500">
        <img src="assets/components/profcom/01-05-2025-2.png" alt="Фотография" height="500">
    </div>


    <p [innerHTML]="'prof-sotr.text10' | translate"></p>
<video width="800" height="500" controls>
        <source src="assets/components/profcom/pamiat.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>

<p class="head2" [innerHTML]="'prof-sotr.text3' | translate"></p>
<div class="display-row">
    <img src="assets/components/profcom/17-09-2024.jpg" alt="Фотография" width="700" height="400">
</div>

<p class="head1" [innerHTML]="'prof-sotr.text4' | translate"></p>

<p [innerHTML]="'prof-styd.text8' | translate"></p>
<div class="display-row">
    <img src="assets/components/prof-styd/19-11-2024-1.png" alt="Фотография" height="500">
    <img src="assets/components/prof-styd/19-11-2024-2.png" alt="Фотография" height="500">
    <img src="assets/components/prof-styd/19-11-2024-3.png" alt="Фотография" height="500">
    <img src="assets/components/prof-styd/19-11-2024-4.png" alt="Фотография" height="500">
</div>
<div class="display-row">
    <img src="assets/components/prof-styd/19-11-2024-5.png" alt="Фотография" height="500">
    <img src="assets/components/prof-styd/19-11-2024-6.png" alt="Фотография" height="500">
    <img src="assets/components/prof-styd/19-11-2024-7.png" alt="Фотография" height="500">
</div>

<p class="head" [innerHTML]="'prof-sotr.text2' | translate"></p>
<div class="display-row">
    <img src="assets/components/profcom/24-04-2024-1.jpg" alt="Фотография" width="500" height="400">
    <img src="assets/components/profcom/24-04-2024-2.jpg" alt="Фотография" width="500" height="400">
    <img src="assets/components/profcom/24-04-2024-3.jpg" alt="Фотография" width="500" height="400">
    <img src="assets/components/profcom/24-04-2024-4.jpg" alt="Фотография" width="400" height="400">
</div>

    <p class="head" [innerHTML]="'prof-sotr.text1' | translate"></p>
    <div class="display-row">
        <img src="assets/components/profcom/19-01-2023-1.png" alt="Фотография" width="500" height="300">
        <img src="assets/components/profcom/19-01-2023-2.png" alt="Фотография" width="500" height="300">
        <img src="assets/components/profcom/19-01-2023-3.png" alt="Фотография" width="300" height="300">
        <img src="assets/components/profcom/19-01-2023-4.png" alt="Фотография" width="500" height="300">
        <img src="assets/components/profcom/19-01-2023-5.png" alt="Фотография" width="500" height="300">
    </div>
</div>